import { DrawerMenuItemList } from 'Components/Layout/DrawerMenu/DrawerMenuItemList'
import type { NavLink } from 'Components/Layout/DrawerMenu/types'
import { t } from 'ttag'

export default function SchoolDrawerMenuContent() {
  const drawerMenuNavLinks: NavLink[] = [
    {
      title: t`Schools`,
      link: `/control-data-management/school-management/schools`
    },
    {
      title: t`Calendars`,
      link: `/control-data-management/school-management/school-calendars`
    }
  ]

  return <DrawerMenuItemList navLinks={drawerMenuNavLinks} rootUrl="/control-data-management" />
}
